import { forwardRef } from 'react';
import { Tooltip, Typography } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import { FadeOutContainer, FadeOutSpacer, IconContainer } from '../components';
import { useSidebarMenu } from '../useSidebarMenu';
import { SidebarMenuItemBadge, SidebarMenuItemContainer } from './styled';
export const SidebarMenuItem = forwardRef((props, ref) => {
    const { to, icon, label, active = false, showBadgeOnMinimize = false, adornmentRight, className, onClick } = props;
    const { minimized } = useSidebarMenu();
    const showBadge = showBadgeOnMinimize && minimized;
    const elementProps = to
        ? {
            as: Link,
            to,
        }
        : {
            onClick,
        };
    return (<SidebarMenuItemContainer $active={active} ref={ref} className={className} {...elementProps}>
      <Tooltip disabled={!minimized} title={label} side="right">
        <IconContainer>
          {icon}
          <SidebarMenuItemBadge $show={showBadge}/>
        </IconContainer>
      </Tooltip>
      <FadeOutContainer $minimized={minimized}>
        <FadeOutSpacer>
          <Typography $fontWeight="regular" $fontSize="medium">
            {label}
          </Typography>
          <IconContainer>{adornmentRight}</IconContainer>
        </FadeOutSpacer>
      </FadeOutContainer>
    </SidebarMenuItemContainer>);
});
